export default {
            'odkryj_dostep':'Descubra todas as categorias e aproveite o acesso total.',
			'odkryj_dostep_opis':  'Apenas um jogador paga e desbloqueia o jogo para ambos!',
            'kontynuuj_gre':  'Continue jogando',
            'zacznij_od_nowa':  'Comece de novo',
            'dolacz_do_gry':  'Entre no jogo',
            'prosze_czekac':  'Por favor, aguarde',
            'zamknij':  '<i class="fa fa-times"></i> Fechar',
            'start_gry':  "Início do jogo",
			'graj':  'Jogar',
			'wpisz_imiona_graczy':'Digite os nomes dos jogadores',
			'twoje_imie':'Seu nome',
			'imie_drugiego_gracza':'nome do segundo jogador',
			'wyslij_zaproszenie':  'Enviar convite <i class="fas fa-chevron-right"></i>',
			'konfiguracja_polaczenia':  'Configuração de conexão',
			'daj_drugiemu':  "Dê ao outro jogador para escanear o código abaixo",
			'wpisz_imiona':  'Digite os nomes de ambos os jogadores',
			'wpisz_rozne_imiona':  'Digite nomes diferentes entre si',
			'odblokowane':  'Todos os níveis foram desbloqueados. Continue jogando!',
			'poziomy':  'Categorias',
			'rozpocznij_gre':  'Iniciar jogo <i class="fas fa-chevron-right"></i>',
			'poziom1':  'Nível 1',
			'poziom2':  'Nível 2',
			'poziom3':  'Nível 3',
			'oczekuje_na_druga_osobe':  'Esperando a resposta da outra pessoa',
			'oczekuje_na_druga_osobe_2':  'Esperando a outra pessoa',
			'graj_dalej':  'Continue jogando <i class="fas fa-chevron-right"></i>',
			'dokoncz_gre':  'Termine o jogo <i class="fas fa-chevron-right"></i>',
			'odpowiadaj_na_pytania':  'Responder a perguntas',
			'pytanie':  'Pergunta',
			'z':'Com',
			'oczekuje_na_osobe':  'Esperando a resposta da outra pessoa',
			'wyniki_rozgrywki':  "Resultados do jogo",
			'gratulacje':  "Parabéns",
			'macie_zgodnosc':  "Você é compatível",
			'znasz_grugiego_gracza':  "Você conhece o outro jogador",
			'zna_ciebie':  "conhece você em",
			'jak_odpowiadaliscie':  '<i class="fas fa-tasks"></i> Veja como você respondeu',
			'pochwal_sie':  '<i class="fas fa-share-alt"></i> Mostre sua pontuação',
			'wasze_odpowiedzi':  "suas respostas",
			'skanuj_kod':"Escanear código",
			'statystyka':  "Estatisticas",
			'statystyka_gry':  "Estatísticas do jogo",
			'powiadom':  '<i class="fas fa-envelope" style="right:auto; left: 15px"></i> Notificar sobre nova versão',
			'zapisalismy_cie':  'Salvamos seu endereço de e-mail',
			'rozpocznij':  'Iniciar <i class="fas fa-chevron-right"></i>',
			'poznajcie_sie':  "Conhecer um ao outro",
			'jak_znasz':  "Matching Halves é um jogo para casais que testará o quanto você conhece seu parceiro e o quanto ele conhece você.",
			'help1':  "Você já iniciou o jogo. Se quiser continuar - pressione o botão abaixo.",
			'help2':  "No entanto, você deseja iniciar o jogo novamente ou com um novo jogador - pressione o botão abaixo.",
			'help3':  "Seja o primeiro jogador a configurar o jogo - adicione os nomes dos jogadores e faça com que o segundo jogador escaneie o código gerado.",
			'help4':  "Depois que o primeiro jogador gerar o código, pressione o botão abaixo e escaneie o código.",
			'help5':  "Após inserir os nomes dos jogadores, aperte o botão \"Enviar convite\" e faça com que o código gerado seja escaneado pelo outro jogador.",
			'help6':  "Dê ao outro jogador para escanear o código abaixo",
			'help7':  "Escaneie o código gerado pelo outro jogador",
			'kup':  "Comprar",
			'zagraj_ponownie':  '<i class="fas fa-play" style="right:auto; left: 15px"></i> Jogar novamente',
			'opis_gry':  'Descrição do jogo',
			'poziom':  'Nível',
			'ext_desc':  '<br>Matching Halves é um jogo para casais que permitirá que você teste o quão bem você conhece seu parceiro e o quão bem ele conhece você.<br><br>Você joga online ao mesmo tempo em dois dispositivos. Vocês dois precisam baixar o jogo na loja.<br><br>Uma pessoa inicia o jogo clicando no botão "Iniciar jogo" e digita seus nomes.<br><br>A outra pessoa entra no jogo clicando no botão Botão "Entrar no jogo" e escaneia o código gerado pela pessoa que iniciou o jogo. Após escanear o código, ambos os jogadores verão o início do jogo e as categorias.<br><br>O aplicativo possui 6 categorias, cada uma com 3 níveis de dificuldade. Você começa com o nível mais fácil, ou seja, nível 1 (completando o nível 1 - permite que você comece o próximo).<br><br>Não desanime com perguntas aparentemente simples, porque quanto mais longe na floresta, mais difícil será e mais picante!<br><br>W ao mesmo tempo, a mesma pergunta aparecerá em seus telefones ou tablets, para a qual você responde sim / não ou marca uma resposta específica. Sua tarefa é apenas clicar na resposta correta.<br><br>Primeiro você responde o que seu parceiro pensa, depois responde por si mesmo o que pensa. Após cada nível, você pode verificar como respondeu e qual porcentagem obteve.<br><br>Você pode interromper o jogo a qualquer momento e finalizá-lo mais tarde, mas se iniciar o jogo novamente, suas respostas anteriores serão excluídas.<br> <br>Divirta-se! <br><br><br><br><br><br>',
			'druga_osoba_odpowiedziala':  'A outra pessoa está esperando sua resposta',
			'confirm_text_1':  'Deseja recomeçar o jogo?',
			'confirm_text_2':  'Você perderá suas respostas anteriores.',
			'yes_button':  '<i class="fa fa-check"></i> Sim, estou começando de novo',
			'no_button':  '<i class="fa fa-times"></i> Não, ainda estou jogando',
			'back':  '<i class="fas fa-chevron-left"></i> voltar',
			'backk':  '<i class="fas fa-chevron-left" style="right:auto;left:15px;"></i> Voltar',
			'podsumowanie_wynikow':  'Resumo do resultado<i class="fas fa-chevron-right"></i>',			
			
			'Życie codzienne': 'Vida cotidiana',
			'Daily life': 'Vida cotidiana',
			'La vida cotidiana': 'Vida cotidiana',
			'Vie courante': 'Vida cotidiana',
			'Alltagsleben': 'Vida cotidiana',
			'Vita di ogni giorno': 'Vida cotidiana',
			'Vida cotidiana': 'Vida cotidiana',
			
			'Osobowość / charakter': 'Personalidade / personagem',
			'Personalità/carattere': 'Personalidade / personagem',
			'Personality / character': 'Personalidade / personagem',
			'Caracter personal': 'Personalidade / personagem',
			'Caractère de la personnalité': 'Personalidade / personagem',
			'Personalidade / personagem': 'Personalidade / personagem',
			'Persönlichkeit Charakter': 'Personalidade / personagem',
			
			'Życie towarzyskie': 'Vida social',
			'Social life': 'Vida social',
			'Vie sociale': 'Vida social',
			'Vida social': 'Vida social',
			'Soziales Leben': 'Vida social',
			'Vita sociale': 'Vida social',
			
			'Wyznawane wartości': 'Valores expostos',
			'Values / beliefs': 'Valores expostos',
			'Valores propugnados': 'Valores expostos',
			'Valeurs adoptées': 'Valores expostos',
			'Valores expostos': 'Valores expostos',
			'Vertraute Werte': 'Valores expostos',
			'Valori sposati': 'Valores expostos',
			
			'Nałogi / nawyki': 'Vícios / hábitos',
			'Habits / Addictions': 'Vícios / hábitos',
			'Adicciones / hábitos': 'Vícios / hábitos',
			'Dépendances / habitudes': 'Vícios / hábitos',
			'Vícios / hábitos': 'Vícios / hábitos',
			'Süchte / Gewohnheiten': 'Vícios / hábitos',
			'Dipendenze/abitudini': 'Vícios / hábitos',
			
			'Seks':'Sexo',
			'Sex':'Sexo',
			'Sexo':'Sexo',
			'Sexe':'Sexo',
			'Sesso':'Sexo',
			
			
            'polski': 'Polski',
            'angielski': 'English',
            'hiszpanski': 'Español',
            'wloski': 'Italiano',
            'francuski': 'Français',
			'portugalski': 'Português',
			'niemiecki': 'Deutsch',
			'jasny': 'Claro',
			'ciemny': 'Escuro',
			'blad_polaczenia': "Erro de conexão. Tente novamente.",
			'przekaz_kod_gry': "O seu código de jogo",
			'przekaz_kod_gry_drugi_gracz': "Você também pode fornecer o código do jogo para o segundo jogador",
"skanuj_kod_aparatem": "Escaneie o código com a câmera",
  "wpisz_kod_recznie": "Insira o código manualmente",
  "wprowadz_kod": "Insira o código recebido",
  "wprowadz_kod_gry": "Insira o código do jogo",
  "help8": "No campo abaixo insira o código do jogo recebido do segundo jogador. Após inseri-lo, o jogo será iniciado automaticamente",
    "nieprawidlowy_kod_gry": "O código inserido não é válido",
  "powrot_do_kategorii": "Voltar às categorias"


}
